import { defineStore } from "pinia";
import { ref, getCurrentInstance } from "vue";
import Utils from "@/utils/util";
import { v4 as uuidv4 } from "uuid";

import {
  apiConfig,
  apiSortList,
  apiAffiliateUrlParse,
  apiCustomerServiceConfig,
  apiMenuList,
  apiChannelMfrList,
  apiDepositType,
  apiDepositWayByType
} from "@/api/index";

export const useAppStore = defineStore("app", () => {
  const appConfig = ref(null) //app配置信息
  const showAppDown = ref(true); //显示头部下载
  const tabbarCur = ref(0);
  const includeList = ref(["layout", "home", "bonus", "profile"]); //路由缓存
  const sortList = ref([]); //分类栏目列表 type 0默认 1游戏 2厂商 3标签 4全部
  const sortGameList = ref([]); //分类栏目对应游戏列表
  const mfrList = ref([]); //厂商列表
  const tagList = ref([]); //标签列表
  const deviceId = ref("");
  const pcNotification = ref(false); //pc右侧通知展开
  const pcMenu = ref(true); //pc左侧菜单展开关闭
  const langs = ref(Utils.$storageGet("langs") || []); //语言
  const lang = ref(Utils.$storageGet("config").LANGUAGE_DEFAULT || "pt"); //当前语言
  const customerConfig = ref([]) //客服配置
  const siteConfig = ref(null) //网站基础配置
  const rebateConfig = ref([]) //返佣比例配置
  const menuList = ref([]) //左侧菜单列表

  const { appContext } = getCurrentInstance();
  const globalProperties = appContext.config.globalProperties;

  const updateShowAppDown = e => {
    showAppDown.value = e;
  };
  // 更新Tabbar索引
  const updateTabbarCur = index => {
    tabbarCur.value = index;
  };
  // 获取app配置文件
  const getConfig = async () => {
    try {
      const { data } = await apiConfig()
      appConfig.value = data
      siteConfig.value = data.site_config
      // 设置网站title
      if (data.site_config && data.site_config.site_description) {
        document.title = data.site_config.site_description;
      }
      // 设置网站图标
      if (data.site_config && data.site_config.site_logo) {
        const faviconLink = document.getElementById('favicon');  // 获取 favicon 元素
        // console.log(faviconLink)
        if (faviconLink) {
          faviconLink.href = data.site_config.site_icon;
        }
      }
      rebateConfig.value = data.rebate_config

      // const r2 = await apiCustomerServiceConfig()
      // // console.log(r2)
      // const groupedByType = r2.data.reduce((acc, item) => {
      //   if (!acc[item.type]) acc[item.type] = [];
      //   acc[item.type].push(item);
      //   return acc;
      // }, {});
      // 遍历 arrayOne，将对应的 list 字段填充
      const result = data.customer_service_type.map(item => {
        // 为每个 item 添加 list 字段，list 是 arrayTwo 中 type 匹配的项
        return {
          ...item,  // 保留原有的字段
          // list: groupedByType[item.type] || []  // 如果没有找到匹配项，则返回空数组
        };
      });
      customerConfig.value = result

    } catch (error) {

    }
  }
  
  // 获取菜单列表
  const getMenuList = async () => {
    try {
      const { data } = await apiMenuList()
      menuList.value = data
      sortList.value = data
      .map((item, index) => ({
        ...item,
        id: index + 1,
      }))
      try {
        // 只处理 type === 2 的菜单项
        const slotMenus = menuList.value.filter(item => item.type === 2);

        // 提取所有 list 中的 mfr_id + platType 并扁平化
        const mfrs = slotMenus.flatMap(menuItem => menuItem.list || []);

        // 去重（根据 mfr_id）
        const uniqueMfrs = [];
        const seen = new Set();

        for (const mfr of mfrs) {
          if (!seen.has(mfr.mfr_id)) {
            seen.add(mfr.mfr_id);
            uniqueMfrs.push({
              ...mfr,
              label: mfr.platType, // 可以换成映射表 if needed
              id: mfr.mfr_id
            });
          }
        }

        // 最终赋值
        mfrList.value = uniqueMfrs;
        console.log("厂商列表",mfrList.value)
      } catch (error) {
        console.error("从 menuList 提取厂商失败", error);
      }
    } catch (error) {

    }
  }
  // 获取游戏厂商列表
  const getMfrList = async () => {
    try {
      const [res1, res3] = await Promise.all([
        apiChannelMfrList({ status: 1 }),
        apiChannelMfrList({ status: 3 }),
      ]);
      // res1.data["EVO Live"].inActiveImg = "@/assets/images/paging-evo.png";
      // res1.data["EVO Live"].img = "@/assets/images/paging-evo1.png";
      // res1.data["PG Slots"].img = "@/assets/images/paging-pg1.png";
      // res1.data["PG Slots"].inActiveImg='@/assets/images/paging-pg.png';
      const combined = {
        ...res3.data,
        ...res1.data
      };
      mfrList.value = Object.entries(combined).map(([key, item],index) => ({
        ...item,
        label: item.name || key,
        id: index+1
      }));
      
      // menuList.value = mfrList.value;
      console.log("sortList:::",sortList.value)
    } catch (error) {
      console.error('获取厂商列表失败', error);
    }
  };

 // 获取游戏分类栏目
  // const getSortList = () => {
  //     sortList.value = mfrList.value;
  // };
  const origin = ref("");
  // 获取地址栏域名参数信息
  const getLocaltionUrlParse = async () => {

    const locationURL = new URL(location.href);
    // console.log(locationURL);
    const whiteList = ["8080", "8081", "8082", "5173", "5174"];
    if (whiteList.includes(locationURL.port)) {
      origin.value = import.meta.env.VITE_BASE_API_CHANNEL;
    } else {
      origin.value = locationURL.origin;
    }
    // console.log(origin.value, locationURL.pathname)
    globalProperties.$Href = origin.value + locationURL.pathname + '#/';
    const hash = locationURL.hash;
    const fragment = hash.slice(2);
    // try {
    //   const { data, code } = await apiAffiliateUrlParse({
    //     serial_code: fragment
    //   });
    //   if (code === 200) {
    //     Utils.$storageSet("source", data.params);
    //   }
    // } catch (error) { }
  };

  const getDeviceId = () => {
    if (!Utils.$storageGet("deviceId")) {
      // 生成并存储唯一标识符
      const newDeviceId = uuidv4();
      Utils.$storageSet("deviceId", newDeviceId);
      deviceId.value = newDeviceId;
    } else {
      // 从 localStorage 中读取唯一标识符
      deviceId.value = Utils.$storageGet("deviceId");
    }
  };

  const updatePcNotification = value => {
    pcNotification.value = value;
  };
  const updatePcMenu = () => {
    pcMenu.value = !pcMenu.value;
  };
  const initLangs = async () => {
    langs.value = Utils.$storageGet("langs");
  };
  const updateLang = value => {
    Utils.$storageSet("lang", value);
    const locationURL = new URL(location.href);
    let newUrl = "";
    if (value == "zh-Hans") {
      newUrl = locationURL.origin + "/cn/" + locationURL.hash;
    } else if (value == "en") {
      newUrl = locationURL.origin + "/en/" + locationURL.hash;
    } else if (value == "pt") {
      newUrl = locationURL.origin + "/pt/" + locationURL.hash;
    }
    console.log(newUrl);
    lang.value = value;
    window.location.href = newUrl;
  };

  const getDepositType = async () => {
    try {
      const { data } = await apiDepositType();
      Utils.$storageSet("depositType", data);
      // 创建一个数组来存储每个请求的 Promise
      // const promises = data.map(async (item, index) => {
      //   try {
      //     const r2 = await apiDepositWayByType({
      //       category_id: item.category_id
      //     });
      //     data[index].ways = r2.data;
      //   } catch (error) {
      //     data[index].ways = [];
      //   }
      // });
      // console.log(data);
      // 等待所有的 Promise 完成
      // await Promise.all(promises);
      // Utils.$storageSet("depositType", data);
    } catch (error) {
    }
  }

  return {
    appConfig,
    getConfig,
    showAppDown,
    updateShowAppDown,
    tabbarCur,
    updateTabbarCur,
    includeList,
    menuList,
    getMenuList,
    mfrList,
    // getMfrList,
    sortList,
    // getSortList,
    sortGameList,
    tagList,
    getLocaltionUrlParse,
    deviceId,
    getDeviceId,
    pcNotification,
    updatePcNotification,
    pcMenu,
    updatePcMenu,
    lang,
    langs,
    initLangs,
    updateLang,
    customerConfig,
    siteConfig,
    rebateConfig,
    getDepositType
  };
});
